<template>
	<div class="admin-bar" v-if="loggedUser" :class="{show: adminBar}">
		<span class="greet"> Hello <b>{{loggedUser.first_name}} {{loggedUser.last_name}}</b></span>
		<div class="items">
			<a href="/admin/dashboard">
				<i class="admin-bar-home"></i> <span>Dashboard</span>
			</a>
			<a href="/admin/users">
				<i class="admin-bar-users"></i> <span>Users</span>
			</a>
			<a href="/admin/sections">
				<i class="admin-bar-sections"></i> <span>Sections</span>
			</a>
			<a href="/admin/pages">
				<i class="admin-bar-pages"></i> <span>Pages</span>
			</a>
			<a href="javascript:void(0)" v-on:click="logout">
				<i class="admin-bar-logout"></i> <span>Logout</span>
			</a>
		</div>
		<span class="cog" v-on:click="toggleAdminBar">
			<i class="admin-bar-cog-alt"></i>
		</span>
	</div>
</template>

<script>
	export default {
		mounted () {
			let isLogged
			// ignore eslint eror for the constant user (declared in index.blade.php)
			/*global user:true*/
			/*eslint no-undef: "error"*/
			if (user) {
				isLogged = JSON.parse(user)
			} else {
				isLogged = false
			}
			this.loggedUser = isLogged
		},
		data () {
			return {
				loggedUser: false,
				adminBar: false
			}
		},
		methods: {
			toggleAdminBar: function () {
				this.adminBar = !this.adminBar
			},
			logout: function () {
				axios.get('/logout').then(() => {
					this.loggedUser = false
				})
			}
		}
	}
</script>
